const r = (t) => ({
  fromAttribute: () => {
    throw new Error(`[PWC: illegal attribute] ${t}`);
  },
  toAttribute: () => {
    throw new Error(`[PWC: illegal attribute] ${t}`);
  }
});
export {
  r as i
};
